export const useEnvironment = () => {
  const config = useRuntimeConfig();
  const version = config.public?.storyblok?.version;

  return {
    isProduction: version === "published",
  };
};
